import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value, locale = 'en-US', currency = 'USD') {
  if (value == null || isNaN(value)) return '—';
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(
    Number(value)
  );
}

export function formatDate(value, locale = 'es') {
  if (!value) return '—';
  try {
    const d = typeof value === 'string' ? new Date(value) : value;
    if (isNaN(d.getTime())) return value;
    return new Intl.DateTimeFormat(locale, {
      dateStyle: 'medium', timeStyle: 'short',
    }).format(d);
  } catch {
    return value;
  }
}

export function formatDateOnly(value, locale = 'es') {
  if (!value) return '—';
  try {
    const d = typeof value === 'string' ? new Date(value) : value;
    if (isNaN(d.getTime())) return value;
    return new Intl.DateTimeFormat(locale, { dateStyle: 'medium' }).format(d);
  } catch {
    return value;
  }
}

export function shortId(id, head = 6, tail = 4) {
  if (!id) return '—';
  const s = String(id);
  if (s.length <= head + tail + 1) return s;
  return `${s.slice(0, head)}…${s.slice(-tail)}`;
}
